module.exports = "build/lp-assets/css/style.css";